export default __webpack_public_path__ + "static/media/calls-per-second.732b36da.svg";